import type { Transition } from "framer-motion";

export const defaultTransition = {
  duration: 0.2,
  ease: "easeOut",
} satisfies Transition;

export const opacityTransitionMotionProps = {
  transition: defaultTransition,
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};
